import { useCallback, useEffect, useState } from 'react';
import { useSocket } from '../provider/socketContext';

/**
 * @brief: Custom hook to manage socket connection state
 * @returns: { status: string } - Current connection status
 */
export function useSocketConnection() {
	const socket = useSocket();
	const [status, setStatus] = useState('DISCONNECTED');

	const onConnectionOpened = useCallback(() => {
		setStatus('CONNECTED');
	}, []);

	const onConnectionClosed = useCallback(() => {
		setStatus('DISCONNECTED');
	}, []);

	useEffect(() => {
		socket.registerEvent('opened', onConnectionOpened);
		socket.registerEvent('closed', onConnectionClosed);
		socket.connect();

		return () => {
			socket.disconnect();
		};
	}, [socket, onConnectionOpened, onConnectionClosed]);

	return { status };
}
